import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGithub, FiLinkedin, FiMail, FiExternalLink } = FiIcons;

const Team = () => {
  const teamMembers = [
    {
      name: "Dimitris Fyntikakis",
      role: "Founder & CEO",
      bio: "Visionary leader with 15+ years in digital transformation. Founder of Hotelyzer and BookMeIn.Events companies, specializing in briging businness with real value.",
      avatar: "https://bmis-local.s3.ap-southeast-1.amazonaws.com/public/bmis-dfynt.jpg",
      github: "#",
      linkedin: "#",
      email: "dimitris@bmi-software.gr"
    },
    {
      name: "Eugene Bozali",
      role: "Founder & CTO",
      bio: "Full-stack architect and open-source advocate. Led success for 20+ enterprises expert in microservices and specializing in cloud architecture and enterprise strategy.",
      avatar: "https://bmis-local.s3.ap-southeast-1.amazonaws.com/public/bmis-reugen.jpg",
      github: "#",
      linkedin: "#",
      email: "eugene@bmi-software.gr"
    },
    {
      name: "George Katelas",
      role: "Co-Founder & BDM",
      bio: "Drives companies growth and profitability by identifying new business opportunities, fostering culture relationships, and developing strategic partnerships",
      avatar: "https://bmis-local.s3.ap-southeast-1.amazonaws.com/public/bmis-rstavros.jpg",
      github: "#",
      linkedin: "#",
      email: "giorgos@bmi-software.gr"
    }
  ];

  return (
    <section id="team" className="py-20 px-6 bg-black/30">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Meet Our <span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">Expert Team</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
           A Startup development studio made by founders, for founders
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
              className="group"
            >
              <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all duration-300 h-full">
                {/* Avatar */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="relative mb-6"
                >
                  <div className="w-32 h-32 mx-auto rounded-full overflow-hidden border-4 border-gradient-to-r from-indigo-500 to-purple-600">
                    <img
                      src={member.avatar}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="absolute inset-0 rounded-full bg-gradient-to-r from-indigo-500/20 to-purple-600/20 scale-0 group-hover:scale-100 transition-transform duration-300"></div>
                </motion.div>

                {/* Name and Role */}
                <h3 className="text-2xl font-bold text-white mb-2 text-center">{member.name}</h3>
                <p className="text-indigo-400 font-medium mb-4 text-center">{member.role}</p>

                {/* Bio */}
                <p className="text-gray-300 text-sm leading-relaxed mb-6 text-center">
                  {member.bio}
                </p>

                {/* Social Links */}
                <div className="flex justify-center space-x-3">
                  <motion.a
                    href={member.github}
                    whileHover={{ scale: 1.1, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                    className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors duration-300"
                    aria-label={`${member.name} GitHub`}
                  >
                    <SafeIcon icon={FiGithub} className="text-white text-lg" />
                  </motion.a>
                  <motion.a
                    href={member.linkedin}
                    whileHover={{ scale: 1.1, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                    className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors duration-300"
                    aria-label={`${member.name} LinkedIn`}
                  >
                    <SafeIcon icon={FiLinkedin} className="text-white text-lg" />
                  </motion.a>
                  <motion.a
                    href={`mailto:${member.email}`}
                    whileHover={{ scale: 1.1, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                    className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors duration-300"
                    aria-label={`Email ${member.name}`}
                  >
                    <SafeIcon icon={FiMail} className="text-white text-lg" />
                  </motion.a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;